export default "__VITE_ASSET__BjqMMLB0__"